import { Alert } from '@rikstv/shared-components';

export const NgtAlertForReceipt = () => (
  <Alert
    dismissible={false}
    style={{ marginTop: '1rem' }}
    intent="info"
    variant="translucent"
    heading="Internettet ditt leveres av NextGenTel"
  >
    Du vil få bekreftelse og mer informasjon om internett-pakken din direkte fra NextGenTel.
  </Alert>
);
